export const TRAVEL_REASON_OPTIONS = [
  'Lua de Mel',
  'Aniversário de casamento',
  'Férias',
  'Viagem de mergulho',
  'Cruzeiro',
  'Outros',
];

export const TRAVEL_BUDGET_OPTIONS = [
  'Entre 10.000 e 15.000',
  'Entre 15.000 e 25.000',
  'Entre 26.000 e 35.000',
  'Entre 36.000 e 45.000',
  'Acima de 46.000',
];

export const TRAVEL_EXPERIENCIES_OPTIONS = [
  'Cultural',
  'Aventura',
  'Gastronômica',
  'Spa e tratamentos',
  'Mergulho',
  'Praia',
  'Natureza',
  'Cidade',
  'Montanha',
  'Esqui',
];

export const DEBUGGER_INITIAL_DATA = {
  travelReason: 'Férias',
  travelPlannedDate: '2023-11-12',
  travelSpeakEng: 'Sim',
  travelLangPref: 'Inglês',
  travelDestinations: [{ label: 'test', value: 'test' }],
  travelCitiesToVisit: [{ label: 'test', value: 'test' }],
  travelExperiencies: [{ label: 'test', value: 'test' }],
  travelBudget: 'Entre 2.000 e 3.000',
  travelPaxAdtNumber: '1',
  travelPaxChdNumber: '0',
  travelPaxInfNumber: '0',
  travelAccommodationCategory: 'Foo',
  travelAccommodationType: 'Bar',
  message: '',
  name: 'john',
  email: 'foo@bar.net',
  phone: '11989998989',
  subscribeNews: false,
  phoneData: {
    number: '11989898989',
    countryName: 'Brasil',
    dialCode: '55',
  },
};
